<template>
	<v-card>
		<AgencyContestUserTable :users="users" @refresh="refresh"
			:possibilities="possibilities"></AgencyContestUserTable>
	</v-card>
</template>

<script>
	import {Api} from "../../../api";
	import AgencyContestUserTable from "../agencyContestUsers/components/AgencyContestUserTable";

	export default {
		name: "AgencyContestUserListView",
		components: {AgencyContestUserTable},

		data() {
			return {
				users: [],
				possibilities: [],
			};
		},

		mounted() {
			this.refresh();
		},

		methods: {
			sortBySurnameAsc (a, b) {
				return a.surname > b.surname ? 1 : b.surname > a.surname ? -1 : 0;
			},

			refresh() {
				Api.get(this, "/agency-contest/users-available-to-add" + "?contestId=" + this.$route.params.id, response => {
					this.possibilities = response.sort(this.sortBySurnameAsc);
				});
				Api.get(this, "/agency-contest/users" + "?contestId=" + this.$route.params.id, response => {
					this.users = response.sort(this.sortBySurnameAsc);
				});
			},
		},

	};

</script>

<style scoped>

</style>
